import React from 'react';
import Rimg from './Rimg.jsx';
import './ProductContext.jsx';
import ProductContext from './ProductContext.jsx';

export default class ProductColors extends React.PureComponent {
  constructor(props) {
    super();
    this.defaultColor = props.product;

    this.state = {
      currentColor: this.defaultColor
    }

    this.colorLabel = this.colorLabel.bind(this);
    this.colorThumb = this.colorThumb.bind(this);
    this._changeColor = this._changeColor.bind(this);
    this._changeProduct = this._changeProduct.bind(this);
  }

  colorLabel() {
    if (this.state.currentColor.title.includes('|')) {
      return <div className="option-header">
        <span className="option-color-name">
          Color:
        </span>
        <span className="option-color-value">
          {this.state.currentColor.title.split('|')[1]}
        </span>
      </div>
    }

    return (null);
  }

  _changeColor(color) {
    this.setState({currentColor: color})
    this.props.onColorChange(color);
  }

  _changeProduct(e, newProduct) {
    e.preventDefault();
    this.props.onProductChange(newProduct, this.props.currentVariant);
  }

  colorThumb(thumb, key) {
    let cName = 'product-color';
    if (this.defaultColor.handle === thumb.handle) {
      cName = 'product-color current-color';
    }
    if (this.props.option1 === 'Wide' && !thumb.tags.includes('width:Wide')) {
      cName += ' incompatible-width';
    }
    if (!thumb.available) {
      cName += ' sold-out';
    }
    if (this.props.product.tags.includes('dt-lgthumbs')) {
      cName += ' lg-thumb'
    }
    const messageTag = thumb.tags.find(tag => tag.startsWith('message:'));
    let thumbMessage = null;
    if (messageTag) {
      thumbMessage = messageTag.replace('message:', '');
    } else if (!thumb.available) {
      if (thumb.tags.includes('BIS')) {
        thumbMessage = this.context.i18n.waitlist;
      } else {
        thumbMessage = this.context.i18n.soldOut;
      }
    }

    return <React.Fragment key={key}>
      <a href={`/products/${thumb.handle}`} title={thumb.title} className={cName} data-no-instant onMouseEnter={e => {this._changeColor(thumb)}} onClick={e => {this._changeProduct(e, thumb)}}>
        <Rimg src={thumb.media.preview_image.src} width={thumb.media.preview_image.width} height={thumb.media.preview_image.height} loading="lazy" alt={thumb.title} data-rimg-min-density="2" />
        {thumbMessage && <span className="thumbnail-message">{thumbMessage}</span>}
      </a>
      {thumb.tags.includes('break-thumb') ? <br /> : null}
      {thumb.tags.includes('mobile-break') ? <br className="desktop--hide" /> : null}
      {thumb.tags.includes('desktop-break') ? <br className="mobile--hide" /> : null}
    </React.Fragment>
  }

  render() {
    if (this.props.productGroup.length > 0) {
      return <div className="product-colors-wrapper" onMouseLeave={e => {this._changeColor(this.defaultColor)}}>
        <this.colorLabel />
        {this.props.productGroup.map((thumbGroup, i) => {
          return <div className={i === this.props.productGroup.length - 1 ? 'product-colors last' : 'product-colors'} key={i}>
            {
              (() => {
                if (this.props.metafields.colorName[`group_${i+1}`]) {
                  return <div className="option-header sub-group">
                    <span className="option-color-name">{this.props.metafields.colorName[`group_${i+1}`]}</span>
                  </div>
                }
              })()
            }
            {thumbGroup.products.map(this.colorThumb)}
          </div>
        })}
      </div>
    }

    return (null);
  }
}

ProductColors.contextType = ProductContext;